import React, { useState } from 'react';
import backgroundImagePath from '../ASSETS/images/pattern-bg.png';
import arrowIconPath from '../ASSETS/images/icon-arrow.svg';

function Header({ ipInfo, fetchIpInfo, errorMessage }) {
	const { ip, isp, location } = ipInfo || {};
	const [searchQuery, setSearchQuery] = useState('');

	function handleSetSearchQuery(e) {
		setSearchQuery(e.target.value);
	}

	function handleFetchIpInfo(e) {
		e.preventDefault();
		fetchIpInfo(searchQuery);
	}

	return (
		<section
			style={{
				backgroundImage: `url(${backgroundImagePath})`,
			}}
			className="header"
		>
			<div className="container">
				<h1 className="header__heading">IP Address Tracker</h1>

				<form onSubmit={handleFetchIpInfo} className="header__searchbox">
					<input
						type="text"
						placeholder="Search for any IP address or domain"
						className="header__searchbox__input"
						value={searchQuery}
						onInput={handleSetSearchQuery}
					/>
					<button className="btn header__searchbox__btn">
						<img src={arrowIconPath} alt="" />
					</button>
				</form>

				<div className="header__result">
					{errorMessage ? (
						<p>{errorMessage}</p>
					) : (
						<>
							<div className="header__result__info">
								<h3 className="header__result__title">IP ADDRESS</h3>
								<p>{ip}</p>
							</div>
							<div className="header__result__info">
								<h3 className="header__result__title">LOCATION</h3>
								{location && (
									<p>
										{location.city}, {location.region}{' '}
										{location.postalCode}
									</p>
								)}
							</div>
							<div className="header__result__info">
								<h3 className="header__result__title">TIMEZONE</h3>
								{location && <p>{location.timezone}</p>}
							</div>
							<div className="header__result__info">
								<h3 className="header__result__title">ISP</h3>
								<p>{isp}</p>
							</div>
						</>
					)}
				</div>
			</div>
		</section>
	);
}

export default Header;
